import * as React from 'react';
import { useBootstrapSeed } from './use-bootstrap';

/**
 * `<BootstrapProvider>` (W127-F2) — Phase 21.
 *
 * Mounts the W127-F1 `/api/v1/auth/me/bootstrap` query once at the
 * app-shell level + seeds the legacy query caches so consumers
 * (`useMembershipsQuery`, `useOrgSubtree('me')`, `useNotificationsUnread`)
 * read hot data without per-mount network round-trips.
 *
 * Closes the throttler-storm root cause the post-Phase-20 audit caught.
 *
 * Mount inside `<QueryClientProvider>` (it uses `useQueryClient` +
 * `useQuery`).
 */
export function BootstrapProvider({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  useBootstrapSeed();
  return <>{children}</>;
}
